<template>
  <DetailCard>
    <template #heading>
      <span class="pi pi-clipboard-check"></span>
      {{ $t(`messages.detail.interior.title`) }}
    </template>
    <div class="p-4">
      <div class="grid grid-cols-[auto_1fr_1fr] gap-x-4 gap-y-2 items-start">
        <!-- Header Row -->
        <div></div> <!-- Empty cell for alignment -->
        <div class="font-bold">{{ $t(`messages.detail.interior.rooms.living`) }}</div>
        <div class="font-bold">{{ $t(`messages.detail.interior.rooms.sanitary`) }}</div>

        <!-- Double Input Fields -->
        <template v-for="(fields, key) in doubleInputFields" :key="key">
          <div class="font-bold text-sm">{{ $t(`messages.detail.interior.${key}`) }}</div>
          <div>
            <PredefinedValuesInputComponent
              category="interior"
              :name="fields[0]"
              :append-on-select="true"
              v-model="interior[fields[0]]"
              class="w-full"
              @update:model-value="evaluationStore.save({ interior: { [fields[0]]: $event } })"
            />
          </div>
          <div>
            <PredefinedValuesInputComponent
              category="interior"
              :name="fields[1]"
              :append-on-select="true"
              v-model="interior[fields[1]]"
              class="w-full"
              @update:model-value="evaluationStore.save({ interior: { [fields[1]]: $event } })"
            />
          </div>
        </template>

        <!-- Single Input Fields -->
        <template v-for="field in inputFields" :key="field">
          <div class="font-bold text-sm">{{ $t(`messages.detail.interior.${field}`) }}</div>
          <div>
            <RatingMultiSelect
              v-if="field === 'hooneosa_seisukord'"
              v-model="interior[field]"
              field="hooneosa_seisukord"
              :options="[1, 2, 3, 4, 5]"
              placeholder="Vali kuni 2 hinnangut"
              :maxSelectedLabels="2"
              :selectionLimit="2"
              fluid
              size="base"
              @update:model-value="evaluationStore.save({ interior: { [field]: $event } })"
              tooltip-position="right"
            />
            <PredefinedValuesInputComponent
              v-else
              category="interior"
              :name="field"
              :append-on-select="true"
              v-model="interior[field]"
              class="w-full"
              @update:model-value="evaluationStore.save({ interior: { [field]: $event } })"
            />
          </div>
          <div></div> <!-- Explicit empty div for the third column -->
        </template>
      </div>
    </div>
  </DetailCard>
</template>

<script setup>
import { storeToRefs } from 'pinia'
import { readonly } from 'vue'
import { useDetailStore } from '@/stores/useDetailStore'
import { useEvaluationStore } from '@/stores/useEvaluationStore'
import PredefinedValuesInputComponent from '../../PredefinedValuesInputComponent.vue'
import DetailCard from '../DetailCard.vue'
import { useI18n } from 'vue-i18n'
import RatingMultiSelect from '@/components/RatingMultiSelect.vue'

const store = useDetailStore()
const evaluationStore = useEvaluationStore()
const { interior } = storeToRefs(store)
const { t } = useI18n()

const inputFields = readonly([
  'ehitiseosa_aknad',
  'ehitiseosa_uksed',
  'santehnika',
  'kohtkindel_sisseseade',
  // 'ehitiseosa_seisukord',
  'hooneosa_seisukord'
])

const doubleInputFields = readonly({
  floors: ['eluruumide_porand', 'sanruumide_porand'],
  walls: ['eluruumide_seinad', 'sanruumide_seinad'],
  ceiling: ['eluruumide_lagi', 'sanruumide_lagi'],
  status: ['eluruumide_seisukord', 'sanruumi_seisukord'],
})
</script>
